import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixcat',
  templateUrl: './fixcat.component.html',
  styleUrls: ['./fixcat.component.css']
})
export class FixcatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
